<template>
  <section class="seo-text o-container o-container--responsive pv-64" :class="addedClass">
    <component :is="seoTextContent" class="seo-text__content" />

    <div class="seo-text__button mt-32" @click="toggleShowAll">
      <div>{{ actionText }}</div>
      <ico-chevron-down-minor class="seo-text__button-icon ml-12" color="#2B4AC7" />
    </div>
  </section>
</template>
<script>
import IcoChevronDownMinor from '@bukalapak/bazaar-visual-next/dist/components/IcoChevronDownMinor';
import HomepageSeoTextContent from './seo-text-contents/HomepageSeoTextContent';

export default {
  name: 'SeoText',
  components: {
    HomepageSeoTextContent,
    IcoChevronDownMinor,
  },

  data() {
    return {
      isShowAll: false,
    };
  },

  computed: {
    actionText() {
      return this.isShowAll ? 'Sembunyikan' : 'Selengkapnya';
    },
    addedClass() {
      return {
        'is-show-all': this.isShowAll,
      };
    },
    seoTextContent() {
      return (
        {
          Homepage: HomepageSeoTextContent,
        }[this.$route.name] || HomepageSeoTextContent
      );
    },
  },

  methods: {
    toggleShowAll() {
      this.isShowAll = !this.isShowAll;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@bukalapak/bazaar-token/dist/web/font.scss';

.seo-text {
  &__content {
    height: 470px;
    overflow: hidden;
  }

  &__button {
    display: flex;
    align-items: center;
    color: #2b4ac7;
    font-weight: $font-weight-bold;

    &:hover {
      cursor: pointer;
    }
  }

  &.is-show-all {
    .seo-text {
      &__content {
        height: auto;
      }

      &__button-icon {
        transform: rotate(180deg);
      }
    }
  }

  ::v-deep {
    font-family: $font-family-primary;
    color: #737373;

    h2,
    h3 {
      margin: 32px 0;
      font-weight: $font-weight-bold;
    }

    h3 {
      font-size: 24px;
    }

    h4 {
      font-size: 20px;
      margin: 16px 0;
    }

    p {
      margin: 16px 0;
    }

    ol,
    ul {
      padding-left: 24px;

      > li::marker {
        font-weight: $font-weight-bold;
      }
    }
  }
}
</style>
